import { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"

import { fetchTrattamentiAsync, selectTrattamenti } from "../redux/searchSlice"

export default function useTrattamentiSearch() {
  const dispatch = useDispatch()
  const trattamentiSearch = useSelector(selectTrattamenti)

  useEffect(() => {
    dispatch(fetchTrattamentiAsync())
  }, [])

  return trattamentiSearch
}
